import { useAppContext } from '../../context/AppContext.js';
import "./style.css";
import api from "../../services/api";
import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Post from "../../componente/post/index.jsx";
import FloatingMenu from "../../componente/menuflutuante/index.jsx"; // Componente do menu flutuante
import TopBar from "../../componente/topbar/index.jsx";

function Principal() {
  const { codcolaborador, selectedCompany, codassinante, accessKey, nomeDoColaborador, fotoPerfil } = useAppContext(); // Acessa os dados do contexto    
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState("");
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  
  // Buscar postagens
  const fetchPosts = async (pageNumber = 1) => {
    api
      .get("/v1/cadastro/colaborador/feed", {
        params: {
          codempresa: selectedCompany,
          pag: pageNumber
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then((response) => {
        const newPosts = response.data;

        setPosts((prev) => [...prev, ...newPosts]);
        setHasMore(newPosts.length > 0);
      })
      .catch((error) => {
        console.error("Erro ao buscar postagens:", error);
      });
  };

  // Criar nova postagem
  const handlePostSubmit = () => {
    if (!newPost.trim()) return;

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0") +
      ":" +
      dt.getSeconds().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    const payload = {
      texto: newPost,
      dtlancamento: dtcadastro,
      codcolaborador, // Ajuste para o autor real
      codassinante,
      codempresa: selectedCompany,
      excluido: "N",
    };

    api
      .post(
        "/v1/cadastro/colaborador/feed",
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then((response) => {
        alert("Postagem criada com sucesso!");
        setPosts([response.data, ...posts]);
        setNewPost("");
      })
      .catch((err) => {
        console.log("Ops! Ocorreu um erro ao criar a postagem: " + err);
      });
  };

  useEffect(() => {
    fetchPosts(page);
  }, [page]);

  return (
    <div>
      <TopBar nomeColaborador={nomeDoColaborador} foto={fotoPerfil} />
      <FloatingMenu />
      <div className='post-container'>
        <div className="new-post">
          <textarea
            placeholder="Digite algo..."
            value={newPost}
            onChange={(e) => setNewPost(e.target.value)}
          />
          <button onClick={handlePostSubmit}>Postar</button>
        </div>
      </div>

      <div id="scrollable-feed" className="feed-container">
        <InfiniteScroll
          dataLength={posts.length} // O número de itens na lista
          next={() => setPage(prevPage => prevPage + 1)} // Função que incrementa a página
          hasMore={hasMore} // Verifica se há mais posts para carregar
          loader={<h4>Carregando...</h4>}
          endMessage={<p>Não há mais postagens.</p>}
          scrollThreshold={0.9} // Inicia o carregamento quando o usuário chegar a 90% do fim
          scrollableTarget="scrollable-feed" // Adiciona o scroll no contêiner com id "scrollable-feed"
        >
          {posts.map((post) => (
            <Post key={post.codfeed} post={post} />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
}

export default Principal;